export default "__VITE_ASSET__Cg8211RQ__"